// Public GA4 Measurement ID (starts with "G-") — not secret, safe to commit,
// it's visible in every page's HTML source on any GA4 site. Get one at
// analytics.google.com > Admin > Create property > Web data stream > copy
// the Measurement ID. Leave empty to disable analytics entirely: no gtag.js
// loads, no data is sent, nothing breaks.
export const GA_MEASUREMENT_ID = "G-E4EKMRVPBP";

const INTERNAL_KEY = "sunbedly_internal";

// Marking our own visits so they don't pollute the numbers.
//
// GA4's built-in filter matches on IP, which is the wrong tool here: a home
// connection gets a dynamic address, so the filter quietly stops matching the
// day the router reconnects and you only notice once the data is already
// dirty. This flag lives in the browser instead — set it once per device by
// visiting any page with ?internal=1, clear it with ?internal=0 — so it keeps
// working from any network, and it also covers phones and tethering.
//
// GA4 reads `traffic_type: "internal"` natively: switch the built-in
// "Internal Traffic" filter to Active and these hits get excluded.
export function isInternalTraffic(): boolean {
  if (typeof window === "undefined") return false;
  try {
    const param = new URLSearchParams(window.location.search).get("internal");
    if (param === "1") {
      window.localStorage.setItem(INTERNAL_KEY, "1");
      return true;
    }
    if (param === "0") {
      window.localStorage.removeItem(INTERNAL_KEY);
      return false;
    }
    return window.localStorage.getItem(INTERNAL_KEY) === "1";
  } catch {
    // Private mode: fall back to counting the visit rather than dropping it.
    return false;
  }
}

export function trackEvent(name: string, params?: Record<string, unknown>): void {
  if (typeof window === "undefined") return;
  const gtag = (window as unknown as { gtag?: (...args: unknown[]) => void }).gtag;
  if (!gtag) return;
  gtag("event", name, {
    ...(params ?? {}),
    ...(isInternalTraffic() ? { traffic_type: "internal" } : {}),
  });
}
